import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/Button/Button';
import { ReadingGroupsPage as messages } from '../messages';

export const ReadingGroupsFooter: VFC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="w-100" style={{ marginRight: 15 }}>
        <Button
          block
          onClick={() => {
            navigate('/');
          }}
        >
          <FormattedMessage {...messages.back} />
        </Button>
      </div>
      <Button
        block
        style={{ whiteSpace: 'pre-wrap' }}
        type="primary"
        onClick={() => navigate('/reading-groups/create')}
      >
        <FormattedMessage {...messages.create} />
      </Button>
    </>
  );
};
